






















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  inheritAttrs: false,
  components: { BaseButton }
})
export default class NoteAddCommentButton extends Vue {

  onClick() {
    this.$emit('onClick', true)
  }
}
